import MockAdapter from 'axios-mock-adapter';

 // Add mock adapter to Axios
function activateMock(axios) {
  const mock = new MockAdapter(axios, { onNoMatch: "passthrough" });

  mock.onGet('/campaigns').reply(200, {
    campaigns: [
      {
        "id": "test-track",
        "title": "Test track",
        "description": "Test for campaigns",
        "imageUrl": "https://jobs.workinfinland.fi/wp-content/uploads/2019/11/shutterstock_281485004-495x400.jpg",
        "externalUrl": "https://jobs.workinfinland.fi",
        "terms": {
          "show": true,
          "title": "Only for testers!",
          "description": "Only a tester can apply to jobs in this campaign.",
          "externalUrl": "https://en.wikipedia.org/wiki/Tester"
        },
        "schedule": {
          "publish": "2021-03-28T13:11:10.830Z",
          "expire": "2021-03-30T13:11:10.830Z"
        },
        "status": "draft",
        "privateJobs": true,
        "filters": {
          "areas": [],
          "categories": [],
          "tags": []
        }
      }
    ]
  });

  mock.onPost('/campaigns').reply(200, {
    message: 'success'
  });

  mock.onGet('/users').reply(200, {
    users: [
      {
        id: "test-user-123",
        firstName: "Firstname",
        lastName: "Lastname",
        email: "firstname.lastname@email.test",
        title: "Tester",
        organization: "Test Organization",
        areas: [
          {
            id: "paijatHame",
            name: "Päijät-Häme"
          },
          {
            id: "southOstrobothnia",
            name: "South Ostrobothnia"
          }
        ]
      }
    ]
  });

  mock.onGet('/pages').reply(200, {
    pages: [
      {
        id: "for-employers",
        navTitle: "For employers",
        createdBy: "Firstname Lastname",
        dateCreated: "1.3.2021",
        editedBy: "Firstname Lastname",
        dateEdited: "1.3.2021",
        title: "For employers",
        subtitle: "Jobs in Finland",
        sidebarContent: `<h3> How do I add my company’s job vacancies to jobsinfinland.fi?</h3><p>You can add your business and a new vacancy by using the Submit job opening form.</p><p> Please note open vacancy listings require processing and approval of your local Talent Hub. After approval, listings will be published on the Jobs in Finland portal.</p>[button=submit-job]`,
        mainContent: `<h3>What are the criteria for selecting the jobs to be declared?</h3><p>Talent Managers of Talent Hub (within city organizations and TE offices) agree with companies on jobs to be accepted and listed to the portal.</p><p>The main criteria for jobs are:</p><ul><li>location of the job: Must be in Finland,</li><li>language skills: does not require Finnish (but English and/or other),</li><li>job quality and requirements: high-quality positions, good working conditions.</li></ul><h3>Is there any restriction or focus on what kind of jobs can be listed?</h3><p>Jobs requiring special skills. Jobs that Finland does not have enough experts for.</p><h3>Are all open vacancies in Finland available on Jobs in Finland?</h3><p>No.</p><h3>What level of education do jobs require?</h3><p>There are jobs with very different requirement and thus there is no restriction on education level. However, the focus is on open vacancy requiring special skills.</p><h3>Is there any restriction about the location of open vacancies?</h3><p>No. Open vacancies can be anywhere in Finland.</p><h3>If I need more information who can I contact?</h3><p>If you are company, you can contact your local talent offices or fill out the form.</p><p>If you are looking for a job please contact the Finnish employment office.</p><p>Contact form for companies:</p>[button=contact-form]`,
        featuredImage: ""
      },
      {
        id: "about",
        navTitle: "About",
        createdBy: "Firstname Lastname",
        dateCreated: "1.4.2021",
        editedBy: "Firstname Lastname",
        dateEdited: "1.4.2021",
        title: "What is jobs in Finland",
        subtitle: "and how does it work?",
        sidebarContent: `<blockquote class="mb-5">With the Jobs in Finland website, we’re supporting Finnish employers in gaining international visibility for positions with a shortage of applicants in Finland. Meanwhile, international talent interested and residing in Finland can find suitable and open positions easier.</blockquote><div class="author" color="primary">Sonja Hämäläinen</div><div class="profession"> migration director at the Ministry of Economic Affairs and Employment
      </div>`,
        mainContent: `<h2>WHAT IS JOBS IN FINLAND</h2><p>Jobs in Finland is part of Talent Boost, an initiative that aims to promote employment-based immigration to tackle the labor shortage in Finland. This service aims to aggregate job openings that don’t require Finnish skills, serving employers in Finland and job seekers in Finland and abroad.</p><h3> Why is there a need for such a new site in addition to existing job sites?</h3><ul><li>Shortage of skills in Finland. Estimates of annual need for international Talent have ranged from 20,000 to 35,000.</li><li>This website is a temporary solution until Job Market Finland, a service developed by KEHA-Center and the Ministry of Economic Affairs and Employment is ready</li><li>This site provides a cumulative view of open vacancies and e.g. thus serves a handy tool for staff at a recruitment fair</li></ul><h3>Who are the organizations behind this service?</h3><ul><li>Business Finland: the owner of the site</li><li>City Talent Advisors (Jobsters): responsible for coordinating the job postings</li><li>Local TE-offices (Jobsters): responsible for coordinating the job postings</li><li>Employers: responsible for open job postings and their quality</li></ul>`,
        featuredImage: ""
      },
    ]
  });

  mock.onGet('/cities').reply(200, {
    cities: []
  });

}

export { activateMock };
